import React, { forwardRef } from 'react';
import MuiChip from '@mui/material/Chip';
import { styled } from './styled';

const getOpacity = (hex, percent) => {
  let hashless = hex.substring(1);
  while (hashless.length < 6) {
    hashless = hashless.split('').map((x) => x + x).join('');
  }
  if (hashless.length > 6) hashless = hashless.substring(0, 6);
  return `#${hashless}${Math.round(percent * 255).toString(16)}`;
};

const Pill = styled(MuiChip, {
  shouldForwardProp: (p) => !['opacity', 'iconColor'].includes(p),
})(({
  theme, opacity = 1, iconColor, size,
}) => ({
  borderRadius: size === 'small' ? '4px' : '8px',
  color: theme.palette.mode === 'light' ? theme.palette.inverted.main : theme.palette.inverted.contrastText,
  background: (
    opacity < 1 ? getOpacity(theme.palette.common.white, opacity) : theme.palette.grey[200]
  ),
  fontSize: size === 'small' ? '12px' : '16px',
  height: size === 'small' ? '20px' : '28px',
  '& .MuiChip-icon': {
    fontSize: size === 'small' ? '14px' : '18px',
    color: ((typeof iconColor === 'function') ? iconColor(theme) : iconColor),
  },
}));

export const Chip = forwardRef((props, ref) => {
  if (props.variant === 'pill') {
    return (
      <Pill {...props} ref={ref} />
    );
  }
  return <MuiChip {...props} ref={ref} />;
});
